
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gymscsRYoDTkB9rTKTq7KPxQkehhJDccNMjgPnrjKZ8M_SkMeta } from "/opt/buildhome/repo/pages/gyms.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as termsM_RN9_459iuNVtH23UOLrjvoINYU4b2nnq0grhd_RmiYYMeta } from "/opt/buildhome/repo/pages/terms.vue?macro=true";
import { default as eventsolhiYTdAs3OdxlS9A7weFHvOg_uQSmkgm67fKyTXpNoMeta } from "/opt/buildhome/repo/pages/events.vue?macro=true";
import { default as confirmIFmOu0BN5xgMZmUEltwjkq7KTLCixwaXkfuu8Fp3P3cMeta } from "/opt/buildhome/repo/pages/confirm.vue?macro=true";
import { default as privacyArxgULVZ2Zifu3wQfKQ0WvqaXaBxDlpI2F7eal9OET8Meta } from "/opt/buildhome/repo/pages/privacy.vue?macro=true";
import { default as backofficeTldwAFj08g7N3jzK3Fp1cewlBOQHmmdginIuRxotm1oMeta } from "/opt/buildhome/repo/pages/backoffice.vue?macro=true";
import { default as _91_91id_93_93_d8S8EjeVbTI1POnrZjHdybDQ8MXejh7n6MxoXtAt3oMeta } from "/opt/buildhome/repo/pages/gym/[[id]].vue?macro=true";
import { default as onboardingZJ1ot5zrkO4kM9JmKxiF_45X_aLfq4AgN5zkWAxxsg6mQMeta } from "/opt/buildhome/repo/pages/onboarding.vue?macro=true";
import { default as _91id_936eABpZioDYFroqRZ86LLQpx6gLeBv0BKcXcl_plK6JcMeta } from "/opt/buildhome/repo/pages/profile/[id].vue?macro=true";
import { default as claim_45profilexVWhuOu8o0Ej4WFi1InZyCmE3ym7UPoaR5td8BIJIicMeta } from "/opt/buildhome/repo/pages/claim-profile.vue?macro=true";
import { default as _91_46_46_46id_932y72aPMPXA_e0wvVZZe7Ul7x0WR_45zbLjOGZnRtB9Je0Meta } from "/opt/buildhome/repo/pages/event/[...id].vue?macro=true";
import { default as organisationsXfAd_gYqBInDKPL17a_JRw0txSco7jIsPrRnV4n5PHgMeta } from "/opt/buildhome/repo/pages/organisations.vue?macro=true";
import { default as indexEPbLo_Qh0clYxIBSQdejsZVGgBicXvTo4awouhofpuAMeta } from "/opt/buildhome/repo/pages/profile/index.vue?macro=true";
import { default as verificationsy_MMUTxtNafiTBWKjzLEBpRzFCJABd6jxXL1sxRvkEEMeta } from "/opt/buildhome/repo/pages/verifications.vue?macro=true";
import { default as _91_91id_93_93qyueu97LJwrXqFZiw92vditG7Y99XvnS2xixUruEeokMeta } from "/opt/buildhome/repo/pages/fighter/[[id]].vue?macro=true";
import { default as newpxLkzBgpo3HObdZ12ZwD_0PII61XO634tlq_459av6HLwMeta } from "/opt/buildhome/repo/pages/fight-offers/new.vue?macro=true";
import { default as _91id_93vRNJSoKdxiIFxcEQQUeBqP5gJ6ZN3HC5RCU7YKm5QvcMeta } from "/opt/buildhome/repo/pages/event/manage/[id].vue?macro=true";
import { default as indexLxtedWj8BvtKS_45_Qt7Qadq7Lq_450V7TDqfsfNdGO1KqYMeta } from "/opt/buildhome/repo/pages/fight-offers/index.vue?macro=true";
import { default as indexo31TVmV4TfdvEQaeYja_mZyw_45rHxyyDuc2hFp8fcFjYMeta } from "/opt/buildhome/repo/pages/verification/index.vue?macro=true";
import { default as indexGlPAKvTeWMjFv8bf8I4035BYqv7YDMCTMls1AOUm2VEMeta } from "/opt/buildhome/repo/pages/action-center/index.vue?macro=true";
import { default as _91_91id_93_93NNVsdfUyhxWXJBn12OZycH_LkEpSN5XeUYSRrHkuizMMeta } from "/opt/buildhome/repo/pages/organisation/[[id]].vue?macro=true";
import { default as detailsIQ3VRHDfxP_5_qCsC5x2xeB7020ZOsJpslfT1ww3C5oMeta } from "/opt/buildhome/repo/pages/verification/details.vue?macro=true";
import { default as _91id_93k6pbQkLQWrnLa8brajrSoTU96SGd_452OBSmr8e5_45UpsQMeta } from "/opt/buildhome/repo/pages/fight-offers/manage/[id].vue?macro=true";
import { default as _91id_93MIQwgLXOpD00xR64mv3E_45Ngfb_45F2Nsw17atYs3bqDZUMeta } from "/opt/buildhome/repo/pages/action-center/thread/[id].vue?macro=true";
import { default as _91token_939rPhFQVREqIq_45zara2Gak_q4EV9vpi6erwcPtl_Q2IsMeta } from "/opt/buildhome/repo/pages/fight-offers/guest/[token].vue?macro=true";
export default [
  {
    name: "gyms",
    path: "/gyms",
    component: () => import("/opt/buildhome/repo/pages/gyms.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/opt/buildhome/repo/pages/events.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    component: () => import("/opt/buildhome/repo/pages/confirm.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "backoffice",
    path: "/backoffice",
    meta: {"middleware":["admin"]},
    component: () => import("/opt/buildhome/repo/pages/backoffice.vue")
  },
  {
    name: "gym-id",
    path: "/gym/:id?",
    component: () => import("/opt/buildhome/repo/pages/gym/[[id]].vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    component: () => import("/opt/buildhome/repo/pages/onboarding.vue")
  },
  {
    name: "profile-id",
    path: "/profile/:id()",
    component: () => import("/opt/buildhome/repo/pages/profile/[id].vue")
  },
  {
    name: "claim-profile",
    path: "/claim-profile",
    component: () => import("/opt/buildhome/repo/pages/claim-profile.vue")
  },
  {
    name: "event-id",
    path: "/event/:id(.*)*",
    component: () => import("/opt/buildhome/repo/pages/event/[...id].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/opt/buildhome/repo/pages/organisations.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/opt/buildhome/repo/pages/profile/index.vue")
  },
  {
    name: "verifications",
    path: "/verifications",
    component: () => import("/opt/buildhome/repo/pages/verifications.vue")
  },
  {
    name: "fighter-id",
    path: "/fighter/:id?",
    component: () => import("/opt/buildhome/repo/pages/fighter/[[id]].vue")
  },
  {
    name: "fight-offers-new",
    path: "/fight-offers/new",
    meta: newpxLkzBgpo3HObdZ12ZwD_0PII61XO634tlq_459av6HLwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fight-offers/new.vue")
  },
  {
    name: "event-manage-id",
    path: "/event/manage/:id()",
    component: () => import("/opt/buildhome/repo/pages/event/manage/[id].vue")
  },
  {
    name: "fight-offers",
    path: "/fight-offers",
    component: () => import("/opt/buildhome/repo/pages/fight-offers/index.vue")
  },
  {
    name: "verification",
    path: "/verification",
    component: () => import("/opt/buildhome/repo/pages/verification/index.vue")
  },
  {
    name: "action-center",
    path: "/action-center",
    component: () => import("/opt/buildhome/repo/pages/action-center/index.vue")
  },
  {
    name: "organisation-id",
    path: "/organisation/:id?",
    component: () => import("/opt/buildhome/repo/pages/organisation/[[id]].vue")
  },
  {
    name: "verification-details",
    path: "/verification/details",
    meta: {"middleware":["admin"]},
    component: () => import("/opt/buildhome/repo/pages/verification/details.vue")
  },
  {
    name: "fight-offers-manage-id",
    path: "/fight-offers/manage/:id()",
    meta: _91id_93k6pbQkLQWrnLa8brajrSoTU96SGd_452OBSmr8e5_45UpsQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fight-offers/manage/[id].vue")
  },
  {
    name: "action-center-thread-id",
    path: "/action-center/thread/:id()",
    component: () => import("/opt/buildhome/repo/pages/action-center/thread/[id].vue")
  },
  {
    name: "fight-offers-guest-token",
    path: "/fight-offers/guest/:token()",
    meta: _91token_939rPhFQVREqIq_45zara2Gak_q4EV9vpi6erwcPtl_Q2IsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fight-offers/guest/[token].vue")
  }
]